import type { StoreMutatorIdentifier, StateCreator } from "zustand";

const storeResetFns = new Set<() => void>();

type ResetStore = <T, Mps extends [StoreMutatorIdentifier, unknown][] = []>(
  f: StateCreator<T, Mps, []>,
  name?: string
) => StateCreator<T, Mps, []>;

export const applyResetMiddleware: ResetStore = (fn, name = "store") => {
  return function (set, get, store) {
    storeResetFns.add(() => {
      const actionName = `${name}/setInitialState`;
      //@ts-ignore-next-line  just ignore
      store.setState(store.getInitialState(), true, actionName);
    });
    return fn(set, get, store);
  };
};

export function resetAllStores() {
  storeResetFns.forEach((resetFn) => {
    resetFn();
  });
}
